<script setup lang="ts">
import { watch } from "vue";
import DecorIcon from "#ui/primitives/decorIcon/DecorIcon.vue";
import type { CartPayControl } from "../cartControls";
import { formatPrice, useAnimatedNumber } from "./animatedPrice";

const props = defineProps<{ control: CartPayControl }>();

const { displayNumber, update } = useAnimatedNumber(Number(props.control.total) || 0, 800);

watch(() => props.control.total, update, { immediate: true });
</script>

<template>
	<button
		type="button"
		class="buttonDefaultWrapper cart_pay_total"
		:id="control.disabled ? 'buttonDefaultDisabled' : ''"
		:disabled="control.disabled"
		:aria-label="control.label"
		@click="control.action"
	>
		<DecorIcon :icon="control.icon" :fallback="control.fallback" />
		<span>{{ formatPrice(displayNumber, control.symbol) }}</span>
	</button>
</template>
